<ng-container *ngIf="!child">
    <div [ngClass]="{'zop-horizontal-navigation-menu-active': trigger.menuOpen,
                 'zop-horizontal-navigation-menu-active-forced': item.active}" [matMenuTriggerFor]="matMenu"
        (onMenuOpen)="triggerChangeDetection()" (onMenuClose)="triggerChangeDetection()" #trigger="matMenuTrigger">
        <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
    </div>
</ng-container>

<mat-menu class="zop-horizontal-navigation-menu-panel" [overlapTrigger]="false" #matMenu="matMenu">

    <ng-container *ngFor="let item of item.children; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <ng-container *ngIf="item.type === 'basic'">
                <div class="zop-horizontal-navigation-menu-item" [disabled]="item.disabled" mat-menu-item>
                    <zop-horizontal-navigation-basic-item [item]="item"
                        [name]="name"></zop-horizontal-navigation-basic-item>
                </div>
            </ng-container>

            <!-- Branch: aside, collapsable, group -->
            <ng-container *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'">
                <div class="zop-horizontal-navigation-menu-item" [disabled]="item.disabled"
                    [matMenuTriggerFor]="branch.matMenu" mat-menu-item>
                    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
                    <zop-horizontal-navigation-branch-item [child]="true" [item]="item" [name]="name"
                        #branch></zop-horizontal-navigation-branch-item>
                </div>
            </ng-container>

            <!-- Divider -->
            <ng-container *ngIf="item.type === 'divider'">
                <div class="zop-horizontal-navigation-menu-item" mat-menu-item>
                    <zop-horizontal-navigation-divider-item [item]="item"
                        [name]="name"></zop-horizontal-navigation-divider-item>
                </div>
            </ng-container>

        </ng-container>

    </ng-container>

</mat-menu>

<!-- Item template -->
<ng-template let-item #itemTemplate>

    <div class="zop-horizontal-navigation-item-wrapper"
        [class.zop-horizontal-navigation-item-has-subtitle]="!!item.subtitle" [ngClass]="item.classes?.wrapper">

        <div class="zop-horizontal-navigation-item" [ngClass]="{'zop-horizontal-navigation-item-disabled': item.disabled,
                 'zop-horizontal-navigation-item-active-forced': item.active}">

            <!-- Icon -->
            <ng-container *ngIf="item.icon">
                <mat-icon class="zop-horizontal-navigation-item-icon" [ngClass]="item.classes?.icon"
                    [svgIcon]="item.icon"></mat-icon>
            </ng-container>

            <!-- Title & Subtitle -->
            <div class="zop-horizontal-navigation-item-title-wrapper">
                <div class="zop-horizontal-navigation-item-title">
                    <span [ngClass]="item.classes?.title">
                        {{item.title | transloco}}
                    </span>
                </div>
                <ng-container *ngIf="item.subtitle">
                    <div class="zop-horizontal-navigation-item-subtitle text-hint">
                        <span [ngClass]="item.classes?.subtitle">
                            {{item.subtitle | transloco}}
                        </span>
                    </div>
                </ng-container>
            </div>

            <!-- Badge -->
            <ng-container *ngIf="item.badge">
                <div class="zop-horizontal-navigation-item-badge">
                    <div class="zop-horizontal-navigation-item-badge-content" [ngClass]="item.badge.classes">
                        {{item.badge.title | transloco}}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

</ng-template>